import { Controller } from "@hotwired/stimulus"

// Filters a long list as the person types, and counts the items switched on.
// Each item carries its searchable words in data-filter-text.
export default class extends Controller {
  static targets = ["input", "item", "empty", "count"]

  connect() {
    this.count()
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let shown = 0
    this.itemTargets.forEach((item) => {
      const match = query.length === 0 || (item.dataset.filterText || "").includes(query)
      item.hidden = !match
      if (match) shown += 1
    })
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown > 0
  }

  count() {
    if (!this.hasCountTarget) return
    const on = this.itemTargets.filter((item) => item.querySelector("input[type=checkbox]")?.checked).length
    this.countTarget.textContent = `${on} of ${this.itemTargets.length} on`
  }
}
